import {
  Box,
  Img,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
} from '@chakra-ui/react';
import { BsSearch } from 'react-icons/bs';
import filterIcon from '../../../assets/Layer 32.svg';

const SearchBar = ({ to, input, setInput }) => {
  return (
    <Stack spacing={4}>
      <InputGroup borderRadius='5px' border='1px solid #FBD5D3'>
        <InputLeftElement fontSize='1.2em' children={<BsSearch />} />
        {/* <InputLeftElement fontSize='1.2em' children={<BsSearch />} /> */}
        <Input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          border='none'
          placeholder='search...'
        />
        <InputRightElement>
          <Filter />
        </InputRightElement>
      </InputGroup>
    </Stack>
  );
};

export default SearchBar;

const Filter = () => {
  return (
    <Menu>
      <MenuButton cursor='pointer' as={Box}>
        <Img src={filterIcon} alt='filter' fontSize='1.2em' />
      </MenuButton>
      <MenuList>
        <MenuItem>Download</MenuItem>
        <MenuItem>Create a Copy</MenuItem>
        <MenuItem>Mark as Draft</MenuItem>
        <MenuItem>Delete</MenuItem>
        <MenuItem>Attend a Workshop</MenuItem>
      </MenuList>
    </Menu>
  );
};
